/** MapTiler: the map's look (a light, low-colour style so status colours stand out) and address lookups. */
export const MAPTILER_KEY = import.meta.env.VITE_MAPTILER_KEY ?? '';

export const mapStyleUrl = () => `https://api.maptiler.com/maps/dataviz-light/style.json?key=${encodeURIComponent(MAPTILER_KEY)}`;
/** Aerial photos with street names: for placing a charger exactly. */
export const satelliteStyleUrl = () => `https://api.maptiler.com/maps/hybrid/style.json?key=${encodeURIComponent(MAPTILER_KEY)}`;

/** The middle of Australia, zoomed out to show the whole country, for an empty map. */
export const AUSTRALIA = { center: [134.5, -27] as [number, number], zoom: 3.2 };

/**
 * A street address's latitude and longitude (in Australia), from MapTiler's geocoding.
 * Null when nothing matches.
 */
export async function findLocation(address: string): Promise<{ latitude: number; longitude: number; place: string } | null> {
  if (!MAPTILER_KEY || !address.trim()) return null;
  const res = await fetch(`https://api.maptiler.com/geocoding/${encodeURIComponent(address)}.json?key=${encodeURIComponent(MAPTILER_KEY)}&country=au&limit=1&language=en`);
  if (!res.ok) throw new Error(`The address lookup failed (${res.status}). Check VITE_MAPTILER_KEY.`);
  const data = (await res.json()) as { features?: { center?: [number, number]; place_name?: string }[] };
  const f = data.features?.[0];
  if (!f?.center) return null;
  return { longitude: f.center[0], latitude: f.center[1], place: f.place_name ?? address };
}
